module.exports = __webpack_public_path__ + "img/boy_010022.42665b7b.png";